<template>
  <div class="toolbar">
    <div class="toolbar__tabs tabs">
      <div class="tabs__list" v-if="tabsList.length !== 0">
        <BaseBtnNew
          v-for="(item, idx) in tabsList"
          :key="idx"
          :name="item.Name"
          :active="idx === activeTab"
          @click-btn="$emit('selectTab', idx)"
        >
          <img :src="item.img" alt="" v-show="item.img">
        </BaseBtnNew>
      </div>
    </div>
    <div class="toolbar__buttons" v-if="buttons">
      <ToolbarIcons type-img="plus" @click-icon="$emit('clickPlus')"/>
      <ToolbarIcons
        v-if="isCopy"
        type-img="copy"
        @click-icon="$emit('clickCopy')"
        :disabled="selectedRowTable === 0"
      />
      <ToolbarIcons
        type-img="trash"
        @click-icon="$emit('clickTrash')"
        :disabled="selectedRowTable === 0"
        red
      />
    </div>
    <div class="toolbar__close" v-if="close">
      <CloseIcon @click="$emit('clickClose')"/>
    </div>
    <div class="toolbar__history" v-if="history">
      <HistoryChangeIcon />
    </div>
  </div>
</template>

<script>
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import HistoryChangeIcon from '@/components/icons/HistoryChangeIcon.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'

export default {
  name: 'TheToolbar',
  components: {
    ToolbarIcons,
    CloseIcon,
    BaseBtnNew,
    HistoryChangeIcon
  },
  props: {
    buttons: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    history: {
      type: Boolean,
      default: false
    },
    selectedRowTable: {
      type: Number,
      default: 0
    },
    tabsList: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 0
    },
    isCopy: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  &__tabs {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin-right: 20px;

    & button {
      margin-right: 10px;
    }
  }

  &__buttons {
    display: flex;
    gap: 20px;
    margin-right: 20px;
  }
}
.tabs__list {
  display: flex;
}
</style>
